<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont0">{{ $t("p0416.statisticalCommissions") }}</span>
    </p>
    <el-col :span="22" :offset="1">
      <el-tabs
        style="min-width: 1000px;user-select: none"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane :label="$t('p0416.noSettled')" name="notPay">
          <p0417 ref="p0417" v-if="tabRefresh.notPay"></p0417>
        </el-tab-pane>
        <el-tab-pane :label="$t('p0416.settled')" name="payed">
          <p0418 ref="p0418" v-if="tabRefresh.payed"></p0418>
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </div>
</template>

<script>
import p0417 from "../../Marketing/CouponCode/P0417";
import p0418 from "../../Marketing/CouponCode/P0418";
export default {
  components: {
    p0417,
    p0418
  },
  data() {
    return {
      // 活跃的标签
      activeName: "notPay",
      tabRefresh: {
        notPay: true,
        payed: false
      }
    };
  },
  methods: {
    // 选择的标签
    handleClick(tab, event) {
      this.activeName = tab.name;
      switch (this.activeName) {
        case "notPay":
          this.switchTab("notPay");
          break;
        case "payed":
          this.switchTab("payed");
          break;
      }
    },
    switchTab(tab) {
      for (let key in this.tabRefresh) {
        if (key === tab) {
          this.tabRefresh[key] = true;
        } else {
          this.tabRefresh[key] = false;
        }
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.main {
  width: 90%;
  margin: 0 auto;
  padding-top: 17px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/CouponCode/P0416.vue